import {
    Modal,
    Radio,
    Row,
    Button,
    Spin,
    Select,
    message,
    Typography,
    Input,
    Popconfirm,
    Divider,
} from "antd";
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../../utils/HTTPClient";

import { useTranslation } from "react-i18next";

const ACTIVE_DOMAIN_STATUS = "active";

const AppboxDomains = ({ domain, setDomain }) => {
    const [loading, setLoading] = useState(false);
    const [domains, setDomains] = useState([]);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const fetch = async () => {
        setLoading(true);
        const res = await HTTPClient.get("/domains/");
        const tmp_domains = res.data.map((data) => data);
        setDomains(tmp_domains);
        setLoading(false);
    };

    useEffect(() => {
        fetch();
    }, []);

    if (loading) return <Spin size="large" />;

    return (
        <>
            {domains && domains.length ? (
                <Select
                    onChange={(e) => setDomain(e)}
                    value={domain}
                    size="large"
                    style={{ width: "100%", marginTop: "10px" }}
                >
                    {domains.map((domain) => (
                        <Select.Option key={domain.domain}>{domain.domain}</Select.Option>
                    ))}
                </Select>
            ) : (
                <>
                    <Row>
                        <Typography.Text>
                            {t("builder.list.link_domain_modal.appbox.no_domains")}
                        </Typography.Text>
                    </Row>
                    <Row>
                        <Button type="primary" onClick={() => navigate("/pro/domains/purchase")} style={{ marginTop: "10px" }}>
                            {t("builder.list.link_domain_modal.appbox.buy")}
                        </Button>
                    </Row>
                </>
            )}
        </>
    );
}

const UserDomains = ({ domain, setDomain, actualDomain }) => {
    const { t } = useTranslation();

    return (
        <div>
            <Typography.Text>{t("builder.list.link_domain_modal.mine_info")}</Typography.Text>
            <Input
                style={{ marginTop: "10px" }}
                value={domain}
                size="large"
                onChange={(e) => setDomain(e.target.value)}
                placeholder="example.com"
            />
        </div>
    );
};

const LinkNewDomain = ({ closeModal, projectId }) => {
    const { t } = useTranslation();
    const [domainType, setDomainType] = useState(null);
    const [domain, setDomain] = useState("");

    const [loading, setLoading] = useState(false);
    const submitLinkDomain = async () => {
        setLoading(true);
        try {
            let response = await HTTPClient.post("/builder/link_domain", {
                project_id: projectId,
                domain,
            });
            if (response.status === 200) {
                closeModal(true);
                message.success(t("builder.list.link_domain_modal.success"));
            }
            if (response.status === 201) {
                closeModal(true);
                message.success(t("builder.list.link_domain_modal.success_appbox"));
            }
        } catch (e) {
            message.error(t("builder.list.link_domain_modal.error"));
        }
        setLoading(false);
    };
    const changeDomainType = (e) => {
        setDomain("");
        setDomainType(e.target.value);
    };

    return (
        <>
            <div
                style={{
                    width: "100%",
                    padding: "10px",
                }}>
                <Row style={{ width: "100%", margin: "10px 0" }}>
                    <Radio.Group onChange={changeDomainType} value={domainType}>
                        <Radio value={"appbox"}>
                            {t("builder.list.link_domain_modal.choises.appbox")}
                        </Radio>
                        <Radio value={"mine"}>
                            {t("builder.list.link_domain_modal.choises.mine")}
                        </Radio>
                    </Radio.Group>
                </Row>

                {domainType === "appbox" && <AppboxDomains setDomain={setDomain} domain={domain} />}

                {domainType === "mine" && (
                    <UserDomains setDomain={setDomain} domain={domain} actualDomain={"-"} />
                )}
            </div>

            {!!domainType && (
                <Button
                    type="primary"
                    onClick={submitLinkDomain}
                    style={{ marginTop: "10px" }}
                    loading={loading}
                    disabled={!domain}>
                    {t("builder.list.link_domain_modal.call_to_action")}
                </Button>
            )}
        </>
    );
};

const DomainInfo = ({ info, closeModal, projectId }) => {
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    if (!info) return null;

    const { status, cname_url, a_ip, subdomain, name } = info;

    const submitUnlinkDomain = async () => {
        setLoading(true);
        try {
            const response = await HTTPClient.delete(`/builder/link_domain/${projectId}`);
            if (response.status === 200) {
                closeModal(true);
                message.success(t("builder.list.link_domain_modal.info.success"));
            }
        } catch (e) {
            message.error(t("builder.list.link_domain_modal.info.error"));
        }
        setLoading(false);
    };

    return (
        <>
            <div
                style={{
                    width: "100%",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                }}>
                {status === ACTIVE_DOMAIN_STATUS ? (
                    <Typography.Text style={{ fontWeight: "bold" }}>
                        <CheckOutlined style={{ color: "green" }} />{" "}
                        {t("builder.list.link_domain_modal.info.active")}
                    </Typography.Text>
                ) : (
                    <>
                        {a_ip &&
                            <>
                                <Row>
                                    <Typography.Text>{t("builder.list.link_domain_modal.info.a_ip")}</Typography.Text>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Typography.Text style={{ fontWeight: "bold" }}>
                                        <p
                                        style={{ cursor: "pointer", fontWeight: "bold" }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(a_ip);
                                            message.success(
                                                t("builder.list.link_domain_modal.copied")
                                            );
                                        }}>
                                        {" "}
                                        <CopyOutlined /> {a_ip} </p>
                                    </Typography.Text>
                                </Row>
                            </>
                        }
                        {a_ip && cname_url && <Divider />}    
                        {cname_url &&
                            <>
                                <Row>
                                    <Typography.Text>{t("builder.list.link_domain_modal.info.c_name_1")}</Typography.Text>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Typography.Text style={{ fontWeight: "bold" }}>
                                        <p
                                        style={{ cursor: "pointer", fontWeight: "bold" }}
                                        onClick={() => {
                                            navigator.clipboard.writeText("www");
                                            message.success(
                                                t("builder.list.link_domain_modal.copied")
                                            );
                                        }}>
                                        {" "}
                                        <CopyOutlined /> www </p>
                                    </Typography.Text>
                                </Row>
                                <Row style={{ marginTop: "20px" }}>
                                    <Typography.Text>{t("builder.list.link_domain_modal.info.c_name_2")}</Typography.Text>
                                </Row>
                                <Row style={{ marginTop: "10px" }}>
                                    <Typography.Text style={{ fontWeight: "bold" }}>
                                        <p
                                            style={{ cursor: "pointer", fontWeight: "bold" }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(cname_url);
                                                message.success(
                                                    t("builder.list.link_domain_modal.copied")
                                                );
                                            }}>
                                            {" "}
                                            <CopyOutlined /> {cname_url} </p>
                                    </Typography.Text>
                                </Row>
                            </>
                        }
                    </>
                )}
            </div>

            <Popconfirm
                title={t("builder.list.link_domain_modal.info.pop_confirm")}
                onConfirm={() => submitUnlinkDomain()}
                okText={t("builder.list.link_domain_modal.info.ok")}
                cancelText={t("builder.list.link_domain_modal.info.no")}>
                <Button danger style={{ marginTop: "10px" }} loading={loading}>
                    {t("builder.list.link_domain_modal.info.unlink_call_to_action")}
                </Button>
            </Popconfirm>
        </>
    );

    if (status === ACTIVE_DOMAIN_STATUS) return;
};

const LinkDomainModal = ({ open, closeModal, projectId }) => {
    const [fetchInfo, setFetchInfo] = useState(false);
    const [info, setInfo] = useState(null);
    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });
    const { t } = useTranslation();
    const fetch = async () => {
        setFetchInfo(true);
        try {
            let response = await HTTPClient.get(`builder/check_domains/${projectId}`);
            const { data } = response;
            setInfo(data);
        } catch (e) {
            message.error(t("builder.list.link_domain_modal.not_found"));
            closeModal();
        }
        setFetchInfo(false);
    };

    useEffect(() => {
        fetch();
    }, []);
    if (!open) return null;

    return (
        <Modal
            open={open}
            title={!fetchInfo ? (
                !info
                    ? t("builder.list.link_domain_modal.title")
                    : t("builder.list.link_domain_modal.title_found") + " " + info.name) : ""
            }
            okText={""}
            cancelText={""}
            width={isLargeScreen ? "50vw" : "100vw"}
            footer={null}
            destroyOnClose
            onCancel={() => {
                closeModal();
            }}>
            {fetchInfo && (
                <div style={{ textAlign: "center" }}>
                    <Spin size="large" style={{ marginTop: "20px" }} />
                </div>
            )}
            {!fetchInfo && !info && <LinkNewDomain closeModal={closeModal} projectId={projectId} />}
            {!fetchInfo && info && (
                <DomainInfo info={info} closeModal={closeModal} projectId={projectId} />
            )}
        </Modal>
    );
};

export { LinkDomainModal };
